import { Controller } from "@hotwired/stimulus"
import { application } from "./application"

// Load the animation and audio only when the dice page connects to Stimulus.
export default class extends Controller {
  async connect() {
    const { default: DiceController } = await import("../wordwolf/dice_controller")
    application.register("dice", DiceController)
  }
}
